import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { InputField, Text, PhoneInput, RadioButton } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { accesslevelOptions } from '../../../config/config';
import ViewItems from '../../../components/ViewItems';
import { getContentKeyAccToLang } from '../../../utils/utils';

const DigitalAuthorization = ({ contentKey }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(corpAOContent?.[contentKey]?.data?.attributes, key, isArabic);
  };

  const [accessLevel, setAccessLevel] = useState(1);
  const [isUndertaking, setIsUndertaking] = useState(false);

  return (
    <div>
      <Text text={getContentKey('digital_channels_authorization')} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />

      <div className='mt-7 mb-9 h-[1px] bg-black/10'></div>

      <div className='space-y-8'>
        <ViewItems>
          <Text text={getContentKey('authorized_user')} className={'text-light-blue'} size={fontSizes.h22} />
          <Text
            text={getContentKey('authorized_user_desc')}
            className={'text-dark-grey/50'}
            size={fontSizes.h12}
          />
        </ViewItems>

        <ViewReverse className={'gap-6'} isResponsive>
          <InputField label={getContentKey('full_name')} isRequired placeholder={getContentKey('full_name')} onChange={() => {}} labelDivClass={'md:h-8 lg:h-6'} />
          <InputField
            label={getContentKey('national_id_or_iqama')}
            isRequired
            placeholder={getContentKey('national_id_or_iqama')}
            onChange={() => {}}
            labelDivClass={'md:h-8 lg:h-6'}
          />
          <InputField label={getContentKey('email_address')} isRequired placeholder={getContentKey('email_address')} onChange={() => {}} labelDivClass={'md:h-8 lg:h-6'} />
        </ViewReverse>

        <ViewReverse className={'gap-6'} isResponsive>
          <PhoneInput label={getContentKey('mobile_number')} placeholder={getContentKey('mobile_number')} onChange={() => {}} />
          <div className='w-full hidden md:flex' />
          <div className='w-full hidden md:flex' />
        </ViewReverse>
      </div>

      <div className='my-10 h-[1px] bg-black/10'></div>

      <div>
        <Text text={getContentKey('access_level')} weight={TextWeight.medium} className={'text-light-blue'} size={fontSizes.h22} />
        <Text
          text={getContentKey('access_level_desc')}
          weight={TextWeight.medium}
          className={'text-dark-grey/50'}
          size={fontSizes.h12}
        />
      </div>

      <ViewReverse className={'gap-2 md:gap-6 mt-8'} isResponsive>
        {accesslevelOptions?.map((item) => (
          <RadioButton
            key={item?.id}
            label={getContentKey(item?.nameKey)}
            selected={accessLevel === item?.id}
            className={'py-2.5'}
            onClick={() => setAccessLevel(item?.id)}
          />
        ))}
      </ViewReverse>

      <div className='my-8 h-[1px] bg-black/10'></div>

      <ViewReverse className={'gap-4 flex-col'}>
        <Text text={getContentKey('undertaking')} weight={TextWeight.medium} className={'text-light-blue'} size={fontSizes.h22} />

        <RadioButton
          label={
            <>
              {getContentKey('undertaking_confirm')}
              <br />
              {getContentKey('undertaking_release')}
            </>
          }
          isSquare
          selected={isUndertaking}
          onClick={() => setIsUndertaking(!isUndertaking)}
          className={'items-start'}
        />
      </ViewReverse>
    </div>
  );
};

export default DigitalAuthorization;
